import React, { useCallback, useState, useMemo } from "react";
import { useDropzone } from "react-dropzone";
import Swal from "sweetalert2";
import { nanoid } from "nanoid";

// FONT AWESOME
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// AWS
import { S3Image } from "aws-amplify-react";
import { API, Auth, Storage } from "aws-amplify";
import { EmitterStatus } from "../../event";

const baseStyle = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "20px",
  borderWidth: 2,
  borderRadius: 2,
  borderColor: "#eeeeee",
  borderStyle: "dashed",
  backgroundColor: "#fafafa",
  color: "#bdbdbd",
  outline: "none",
  transition: "border .24s ease-in-out",
};

const activeStyle = {
  borderColor: "#3b82f6",
};

const acceptStyle = {
  borderColor: "#00e676",
};

const rejectStyle = {
  borderColor: "#ff1744",
};

function Banner({ data, getData }) {
  const [banners, setBanners] = useState(
    data?.map((el) => {
      return {
        ...el,
        unique_id: nanoid(),
        local_status: "USING",
      };
    }) || []
  );

  const onDrop = useCallback((acceptedFiles) => {
    acceptedFiles.forEach((file) => {
      let newBanner = { file, base64: null };
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onabort = () => console.log("file reading was aborted");
      reader.onerror = () => console.log("file reading has failed");
      reader.onload = () => {
        setBanners((prev) => {
          newBanner.base64 = reader.result;
          if (prev) {
            return [...prev, { newBanner, local_status: "CREATE" }];
          }

          return [{ newBanner }];
        });
      };
    });
  }, []);

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({ onDrop });

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isDragActive, isDragReject, isDragAccept]
  );

  const onDelete = (unique_id) => () => {
    const prev = [...banners];
    const findIndex = prev.findIndex(
      (banner) => banner.unique_id === unique_id
    );
    prev[findIndex].local_status = "DELETE";

    setBanners(prev);
    // setBanners((prev) => {
    //   // const prevItem = [...prev];
    //   // prevItem[index] = {
    //   //   ...prevItem[index],
    //   //   local_status: "DELETE",
    //   // };
    //   // console.log("PREV ITEM", prevItem);
    //   // return [...prevItem];
    // });
  };

  const onSubmit = async () => {
    const result = await Swal.fire({
      title: "คุณยืนยันที่จะอนุมัตินี้หรือไม่ ?",
      showCancelButton: true,
      confirmButtonText: `บันทึก`,
      cancelButtonText: "ยกเลิก",
      showLoaderOnConfirm: true,
      showLoaderOnDeny: false,
      preConfirm: async () => {
        try {
          for (const banner of banners) {
            const local_status = banner?.local_status;
            switch (local_status) {
              case "CREATE":
                await CreateBanner(banner);
                break;
              case "DELETE":
                await DeleteBanner(banner);
                break;
              default:
                console.log("USING"); //ค่าเก่าไม่มีอะไรเปลี่ยนแปลง
                break;
            }
          }
        } catch (error) {
          await EmitterStatus("ERROR", { logMessage: error });
        }
      },
    });
    if (!result.isConfirmed) return;
    await EmitterStatus("SUCCESS");
    await getData();
  };

  const CreateBanner = async (banner) => {
    let newBanner = "";
    const fileName = `${new Date().getTime()}_${banner?.newBanner?.file?.name}`;
    newBanner = await Storage.put(fileName, banner.newBanner.file);
    await API.post("MoneyHubAdmin", `/banner`, {
      body: {
        banner_key: newBanner?.key,
      },
      headers: {
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    });
  };

  const DeleteBanner = async (banner) => {
    await API.del("MoneyHubAdmin", `/banner/${banner.banner_id}`, {
      body: {
        timestamp: banner.timestamp,
      },
      headers: {
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    });
  };

  const DeleteImage = (index) => {
    return (
      <div className="flex items-center justify-center mt-4 w-full">
        <button
          onClick={onDelete(index)}
          className="px-2 py-1 border hover:bg-red-400 text-white bg-red-500 w-full rounded duration-300"
        >
          ลบ
        </button>
      </div>
    );
  };

  return (
    <div>
      <div className="grid grid-cols-3 gap-4 h-full w-full">
        {banners?.length > 0 &&
          banners
            .filter((banner) =>
              ["USING", "CREATE"].includes(banner.local_status)
            )
            .map((banner, index) => {
              if (banner.banner_key) {
                return (
                  <div
                    className="flex flex-col  justify-start  w-full  mx-4 border p-4 rounded-lg h-full"
                    key={index}
                  >
                    <div className="w-full h-full  object-contain  flex flex-col justify-center items-center">
                      <S3Image
                        imgKey={banner.banner_key}
                        className=" h-44 w-full"
                      />
                    </div>
                    {DeleteImage(banner.unique_id)}
                  </div>
                );
              } else if (banner.newBanner) {
                return (
                  <div
                    className="flex flex-col  justify-start  w-full  mx-4 border p-4 rounded-lg h-full"
                    key={index}
                  >
                    <div className="w-full h-full  object-contain  flex flex-col justify-center items-center">
                      <img
                        src={banner.newBanner.base64}
                        className="h-44 w-full"
                      />
                    </div>
                    {DeleteImage(banner.unique_id)}
                  </div>
                );
              }

              return null;
            })}
        <div className=" pr-8">
          <div className="flex flex-col  justify-start  w-full h-full   mx-4 border p-4 rounded-lg">
            <div
              {...getRootProps({ style })}
              className="items-center flex justify-center"
            >
              <input {...getInputProps()} />
              <FontAwesomeIcon icon={faPlus} />
              <div className="mt-2 text-sm">(สกุลไฟล์ jpg. หรือ png.) </div>
            </div>
            <div className=" mt-6  flex justify-center items-center">
              <button
                className=" bg-blue-500 hover:bg-blue-600 text-white p-1.5 px-4 w-full rounded"
                onClick={onSubmit}
              >
                ยืนยัน
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Banner;
{
  /* <div className="flex flex-col mx-4 border rounded-lg p-4" key={index}>
                  <img src={banner.newBanner.base64} />
                  {DeleteImage(index)}
                  <div className="flex flex-col    justify-start mt-6">
                    <div {...getRootProps({ style })}>
                      <input {...getInputProps()} />
                      <FontAwesomeIcon icon={faPlus} />
                      <div className="mt-2 text-sm">
                        (สกุลไฟล์ jpg. หรือ png.){" "}
                      </div>
                    </div>
                    <div className=" mt-6  flex justify-center items-center">
                      <button
                        className=" bg-blue-500 text-white p-1.5 px-4 w-full rounded"
                        onClick={onSubmit}
                      >
                        ยืนยัน
                      </button>
                    </div>
                  </div>
                </div> */
}
